import React from 'react'
import { ArrowLeft } from 'react-feather';
import { ControlledInput } from "../../common/Input/Input";
import Select from "react-select";

const AddNewPartner = (props) => {
    return (
        <div>
            <span style={{ cursor: "pointer" }} onClick={props.onBackClick}>
                <ArrowLeft style={{ marginRight: "10px" }} />
            </span>
            <label>
                <b>New Service Partner</b>
            </label>
            <div className="row mt-2 mb-5">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Hint: To update existing record select "Service Partner" in the below dropdown</label><br />
                    <Select
                        options={props.servicePartnerOptions}
                        onChange={props.onServicePartnerNameChange}
                        value={props.selectedServicePartnerNames}
                        placeholder="Select Service Partner"
                    />
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Partner Name <span className="required">*</span></label><br />
                    <ControlledInput
                        name="sName"
                        placeholder="Service Partner Name"
                        value={props.servicePartnerFields.sName || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        onKeyDown={(event) => {
                            // Check if the key pressed is a number key
                            if (event.key >= '0' && event.key <= '9') {
                                event.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Partner Email <span className="required">*</span></label><br />
                    <ControlledInput
                        name="sServicePartnerEmail"
                        placeholder="Service Partner Email"
                        value={props.servicePartnerFields.sServicePartnerEmail || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        autoComplete="off"
                    />
                </div>

                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Partner Organisation <span className="required">*</span></label><br />
                    <ControlledInput
                        name="sServicePartnerOrg"
                        placeholder="Service Partner Organisation"
                        value={props.servicePartnerFields.sServicePartnerOrg || ""}
                        onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-4">
                    <label style={{ marginBottom: "10px" }}>Service Partner Mobile No. <span className="required">*</span></label><br />
                    <ControlledInput
                        name="sMobileNumber"
                        placeholder="Service Partner Mobile"
                        value={props.servicePartnerFields.sMobileNumber || ""}
                        onChange={({ target: { name, value } }) => {
                            const maxLength = 10;
                            if (value.length <= maxLength) {
                                props.handleChange(name, value);
                            }
                        }}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    />
                </div>
            </div>

            <div className="row mt-3">
                <div className="col">
                    <button className='my-services-model-submit-btn' onClick={props.onSubmitBtnClick}>Submit</button>
                    <button className='my-services-model-submit-btn ml-2' onClick={props.resetBtn}>Reset</button>
                </div>
            </div>
        </div>
    )
}

export default AddNewPartner
